import { SupportTicketId } from "@redotech/effect-api-shared/ids/definitions";
import { Option, Schema } from "effect";

export interface SupportTicketNotificationRef {
  supportTicketId: string;
}

export interface SupportTicketPresenceRef extends SupportTicketNotificationRef {
  userId: string;
}

const decodeSupportTicketIdOption = Schema.decodeUnknownOption(SupportTicketId);

/**
 * Brand a raw realtime `supportTicketId` (from an SSE event or REST snapshot)
 * into a {@link SupportTicketId}. Returns `undefined` when the value isn't a
 * valid `cnv_<base62>` id — callers should drop those events rather than crash.
 *
 * Stores that still have legacy ticket ids reachable by the notification stream
 * would otherwise throw a `ParseError` out of `SupportTicketId.make`, which
 * propagates to the React error boundary and takes down every inbox view. This
 * mirrors {@link parsePresenceUserId}: unparsable legacy wire shapes are dropped
 * at the seam instead of surfaced.
 */
export function notificationSupportTicketId(
  event: SupportTicketNotificationRef,
): SupportTicketId | undefined {
  return Option.getOrUndefined(
    decodeSupportTicketIdOption(event.supportTicketId),
  );
}

export function supportTicketPresenceKey(
  event: SupportTicketPresenceRef,
): string {
  return `${event.supportTicketId}:${event.userId}`;
}
